import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivityEntityName, DomainType, FormPickerRequest, FormTemplate } from '@jms/model';
import { Observable, map, catchError, of } from 'rxjs';
import * as Enumerable from 'linq';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;


@Injectable()
export class ActivityFormTemplateService {

    private readonly _api = '/api/form/template';

    private get api() {
        if (ConfigService.environment.domainType === DomainType.ContractorPortal) {
            return `https://__tenant__${this._api}`;
        }

        return this._api;
    }

    constructor(
        private http: HttpClient
    ) { }


    public getTemplates(mergeWith: ActivityEntityName): Observable<FormTemplate[]> {
        return this.http
            .get<FormTemplate[]>(`${this.api}/picker/${mergeWith}`)
            .pipe(
                map(templates => {
                    return Enumerable
                        .from(templates)
                        .orderBy(x => x.title)
                        .toArray();
                }),
                catchError(() => of(null))
            );
    }

    public getTemplatesWithRequest(request: FormPickerRequest): Observable<FormTemplate[]> {
        return this.http
            .post<FormTemplate[]>(`${this.api}/picker`, request)
            .pipe(
                map(templates => {
                    return Enumerable
                        .from(templates)
                        .orderBy(x => x.title)
                        .toArray();
                }),
                catchError(() => of(null))
            );
    }

}